import { LitElement, html } from "lit";

import { customElement, state } from "lit/decorators.js";

import { styles } from "./worlds-layout.css";

import "../content-container/content-container";

@customElement("worlds-layout")
export class WorldsLayout extends LitElement {
  static override styles = [styles];

  @state()
  private hasSecondaryContent = false;

  protected override firstUpdated() {
    // Check if secondary-content slot has any content
    const secondarySlot = this.shadowRoot?.querySelector('slot[name="secondary-content"]') as HTMLSlotElement;
    if (secondarySlot) {
      this.hasSecondaryContent = secondarySlot.assignedElements().length > 0;

      // Listen for slot changes to update layout dynamically
      secondarySlot.addEventListener("slotchange", () => {
        this.hasSecondaryContent = secondarySlot.assignedElements().length > 0;
      });
    }
  }

  protected override render() {
    return html`
      <div class="layout-container ${this.hasSecondaryContent ? "" : "no-secondary"}">
        <!-- Actions Area with 2 slots -->
        <div class="actions">
          <slot name="navigation-buttons"></slot>
          <slot name="action-buttons"></slot>
        </div>

        <!-- Main Content Area -->
        <content-container variant="primary" columns="1">
          <div slot="column">
            <slot name="main-content"></slot>
          </div>
        </content-container>

        <!-- Secondary Area (hidden on mobile) -->
        <content-container variant="secondary" columns="1">
          <div slot="column">
            <slot name="secondary-content"></slot>
          </div>
        </content-container>
      </div>
    `;
  }
}
